import React from 'react'

function Portfolio() {
  const caseStudies = [
    {
      id: 1,
      image: "assets/img/all-images/case/case-img1.png",
      tag: "Your exclusive personal concierge and lifestyle management service, helping improve your work-life balance, connecting you to lifestyle experts and advisors through your mobile device.",
      title: "UConcierge Service App"
    },
    {
      id: 2,
      image: "assets/img/all-images/case/case-img2.png",
      tag: "Designed to improve the consistency of our operations and process efficiency, and add value to the customer through time and cost savings.",
      title: "Courier Delivery App"
    },
    {
      id: 3,
      image: "assets/img/all-images/case/case-img3.png",
      tag: "HOMECARE2GO® is created to connect people seeking help to verified care providers that can serve them. There are millions of people looking for care at one given time, But for most people, navigating the system to get help has been very complicated, time-",
      title: "HomeHealth Services App"
    },
    {
      id: 4,
      image: "assets/img/all-images/case/case-img9.png",
      tag: "This app is a marketplace for beauty and grooming where the customer can easily discover beautician and stylist and book them online at their preferred location.",
      title: "Stylist Booking App"
    },
    {
      id: 5,
      image: "assets/img/all-images/case/case-img10.png",
      tag: "Sell Buy Drive Auctions Are Designed To Provide The Best Experience For Buyers And Sellers Alike",
      title: "Place For Online Car Auctions"
    },
    {
      id: 6,
      image: "assets/img/all-images/case/case-img11.png",
      tag: "Care Coordinations is HIPAA secured & AI-powered communication app for Home Health & Hospice Care Organizations. Our simple, intuitive, and proprietary interface allows front and backend team members to share secure messages, images, and documents in real",
      title: "Care Coordinations App"
    }
  ];

  return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: "url(assets/img/all-images/bg/hero-bg1.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Portfolio</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> <span>Portfolio</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Case Studies Area */}
      <div className="case-inner-area sp1">
        <div className="container">
          
                  <div className="about-header-area heading2">
                    <h5>
                      <span>
                        <img src="/assets/img/icons/sub-logo1.svg" alt="sub-logo" />
                      </span>
                      Design. Develop. Deliver
                    </h5>
                    <div className="space16"></div>
                    <p data-aos="fade-left" data-aos-duration="800">
                     Explore our portfolio highlighting innovative—yet practical—solutions we’ve built. From
sleek mobile apps and robust SaaS tools to intelligent automation systems and IoT platforms,
see how we deliver real business impact.
                    </p>
                    <div className="space100"></div>
                  </div>
          
          <div className="row">
            
            {caseStudies.map((caseStudy) => (
              <div key={caseStudy.id} className="col-lg-6 col-md-6">
                <div className="case-slider-boxarea">
                  <div className="img1 image-anime">
                    <img src={caseStudy.image} alt="" />
                  </div>
                  <div className="content-area">
                    <a href="case-single.html">{caseStudy.title}</a>
                    <div className="space16"></div>
                    <p>{caseStudy.tag}</p>
                  </div>
                </div>
              </div>
            ))}
            
          </div>
        </div>
      </div>
    </>
  )
}

export default Portfolio
